module.exports = __webpack_public_path__ + "static/media/search3.50d3614b.png";